import { Level, LevelName, LevelStage } from './level';
import { ThemeName } from '../themes/theme';
import { CharacterName } from '../../vehicle/Character';
import { VehicleHandlingProfiles } from '../../vehicle/VehicleHandlingProfiles';
import { RampSkins } from '../entities/Ramp';

export const level1: Level = {
  id: LevelName.Level1,
  theme: ThemeName.FunStreet,
  scoring: {
    starRatings: [0.5, 0.75, 0.9]
  },
  hero: CharacterName.Bam,
  heroVehicleHandling: VehicleHandlingProfiles.heroLvl1,
  villain: CharacterName.Prank,
  villainVehicleHandling: VehicleHandlingProfiles.villainLvl1,
  stages: [
    {
      stageType: LevelStage.LootDropSection,
      dropQuantity: 20,
      dropRateMin: 500,
      dropRateMax: 500,
      specialDropInterval: 5,

      shouldVillainUseTrapWhileDropping: false,
      shouldTriggerOnDrops: true,
      weaponTriggerPoints: [10]
    },
    {
      stageType: LevelStage.RampSection,
      rampSkin: RampSkins.Normal,
      rampsToJump: 1
    },
    {
      stageType: LevelStage.ChargeUpSection
    },
    {
      stageType: LevelStage.LootDropSection,
      dropQuantity: 30,
      dropRateMin: 400,
      dropRateMax: 400,
      specialDropInterval: 5,

      shouldVillainUseTrapWhileDropping: false,
      shouldTriggerOnDrops: true,
      weaponTriggerPoints: [10]
    },
    {
      stageType: LevelStage.RampSection,
      rampSkin: RampSkins.Normal,
      rampsToJump: 1
    },
    {
      stageType: LevelStage.ChargeUpSection
    },
    {
      stageType: LevelStage.LootDropSection,
      dropQuantity: 40,
      dropRateMin: 250,
      dropRateMax: 250,
      specialDropInterval: 5,

      shouldVillainUseTrapWhileDropping: false,
      shouldTriggerOnDrops: true,
      weaponTriggerPoints: [15]
    },
    {
      stageType: LevelStage.RampSection,
      rampSkin: RampSkins.Normal,
      rampsToJump: 1
    },
    {
      stageType: LevelStage.ChargeUpSection,
      // chargeAmount: 3
    }
  ]
};
